import { gql } from '@apollo/client'

export const USER_CREATE_MUTATION = gql`
  mutation USER_CREATE_MUTATION($user: UserCreateInput!) {
    userCreate(user: $user) {
      ok
    }
  }
`

export const USER_UPDATE_MUTATION = gql`
  mutation USER_UPDATE_MUTATION($id: ID!, $companyId: ID!, $user: UserUpdateInput!) {
    userUpdate(id: $id, companyId: $companyId, user: $user) {
      ok
    }
  }
`
